@layer module {
.accounts-layout {
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
    }

.accounts-layout > :global(.account-list) {
            min-width: 0;
    }

.accounts-layout > :global(.account-workspace) {
            min-width: 0;
    }
} // layer module










@layer app {
.accounts-layout {
            flex: 1 1 auto;
            gap: $size-16;
    }

.accounts-layout > :global(.account-list) {
            flex: 1 1 $size-320;
            max-width: $size-420;
    }

.accounts-layout > :global(.account-workspace) {
            flex: 2.4 1 $size-560;
    }

      @media (max-width: 960px) {
                .accounts-layout > :global(.account-list) {
                        max-width: none;
                    }
          }
} // layer app
